import http from '../http/http';
import URL from '../constant/URL';

const { GM } = URL.API;

// 북패드 로그인 (회원가입)
export const mbrspLoginAPI = async (data) => {
  let result = null;

  await http.request({
    url: `${URL.API.PAD_LOGIN}`,
    type: http.TYPE.LOGIN,
    method: http.METHOD.POST,
    data,
    success: (resp) => { result = resp; },
    error: (error) => { throw error }
  });
  return result;
}

// 특정 학습자의 진입 로그를 쌓고 학습회원의 최근 학습이력조회
export const membersLearnersAPI = async (parentId, learnerId) => {
  let result = null;
  await http.request({
    url: `${URL.API.MEMBERS.MEMBERS}/${parentId}/learners/${learnerId}`,
    success: (resp) => {result = resp;},
    error: (error) => {throw error;},
  });
  return result;
};

// 교문 로그인
export const gmLoginAPI = async (data) => {
  let result = null;

  // result = {
  //   lrnMbrId: 'LRN20210820180000584',
  //   sbsceMbrId: 'MBR20210820180000789',
  //   accessToken: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIkRU5iQjQyUTJAbmF0ZS5jb20iLCJhdGgiOlsiUk9MRV9VU0VSIl0sImNobiI6IkJSUzEwMDAiLCJtYnIiOiJNQlIyMDIxMDgyMDE4MDAwMDc4OSIsImlzcyI6IndqdGhpbmtiaWciLCJpYXQiOjE2NjMxMzAxODIsImV4cCI6MTY2MzIxNjU4Mn0.PxZOGF1qFyERjAWjLearuNDAR_lmjtid4JO8DuCxCH3ZRJfx8kyXO0720N5Y0lXY_ceuQFdlosFmpQfMuZV1DA',
  // }

  await http.request({
    url: `${GM.PAD_LOGIN}`,
    type: http.TYPE.LOGIN,
    method: http.METHOD.POST,
    data,
    success: (resp) => { result = resp; },
    error: (error) => {
      // console.log({ error });
      throw error
    }
  });

  return result;
}

// CP모델 로그인
export const cpLoginAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.CP_LOGIN}`,
    type: http.TYPE.LOGIN,
    method: http.METHOD.POST,
    data,
    success: (resp) => {
      result = resp;
    },
    error: (error) => {
      // console.log({ error });
      throw error
    }
  });

  return result;
};

// 구글 탈퇴
export const revokeEmailAPI = async (data) => {
  let result = null;
  await http.request({
    url: GM.GOOGLE_LEAVE,
    method: http.METHOD.DELETE,
    data,
    success: (resp, code) => {
      console.log({ resp, code });
      result = {
        resp, code
      }
    },
    error: (error) => {
      // console.log({ error });
      throw error
    }
  });
  return result;
};